import PropTypes from 'prop-types';

import './OrderingSwitch.css';

import { buildClass } from '../../libs/classes';

export const orderType = {
	ascending: 0,
	descending: 1,
};

/**
 * Ordering switch
 * @component
 */
export const OrderingSwitch = ({ state, onClick }) => {
	return (
		<div
			className={buildClass('ordering-switch').add(state === orderType.descending, 'descending', 'ascending')}
			title={state === orderType.descending ? 'Descending ordering' : 'Ascending ordering'}
			onClick={onClick}
		/>
	);
};

OrderingSwitch.propTypes = {
	// Ordering state
	state: PropTypes.number.isRequired,
	// On click callback function
	onClick: PropTypes.func.isRequired,
};

export default OrderingSwitch;
